<div class="filter">
  <div class="filter__header" (click)="isExpanded = !isExpanded" [ngClass]="!isExpanded ? 'remove-border' : ''">
    <div class="filter__header__title">
      <mat-icon class="filter__header__title__icon">filter_alt</mat-icon>
      {{ 'VOLUMETRY.FILTERS.TITLE' | translate }}
    </div>
    <div class="filter__header__expand">
      <span *ngIf="!isExpanded">{{ 'VOLUMETRY.FILTERS.SEE_MORE' | translate }}</span>
      <span *ngIf="isExpanded">{{ 'VOLUMETRY.FILTERS.SEE_LESS' | translate }}</span>
    </div>
  </div>
  <div class="filter__content" *ngIf="isExpanded">
    <div class="filter__content__date">
      <span class="filter__content__date__title">{{ 'VOLUMETRY.FILTERS.OPENED_DATE' | translate }}</span>
      <fc-date-input
        [control]="filterForm.get('openedAtGte')"
        [placeholder]="'VOLUMETRY.FILTERS.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="VOLUMETRY.FILTERS.ERRORS"
        [max]="filterForm.get('openedAtLte').value"
      ></fc-date-input>
      <span>{{ 'VOLUMETRY.FILTERS.UNTIL' | translate }}</span>
      <fc-date-input
        [control]="filterForm.get('openedAtLte')"
        [placeholder]="'VOLUMETRY.FILTERS.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="VOLUMETRY.FILTERS.ERRORS"
        [min]="filterForm.get('openedAtGte').value"
      ></fc-date-input>
    </div>

    <div class="filter__content__date">
      <span class="filter__content__date__title">{{ 'VOLUMETRY.FILTERS.SCHEDULED_DATE' | translate }}</span>

      <fc-date-input
        [control]="filterForm.get('scheduledAtGte')"
        [placeholder]="'VOLUMETRY.FILTERS.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="VOLUMETRY.FILTERS.ERRORS"
        [max]="filterForm.get('scheduledAtLte').value"
      ></fc-date-input>
      <span>{{ 'VOLUMETRY.FILTERS.UNTIL' | translate }}</span>
      <fc-date-input
        [control]="filterForm.get('scheduledAtLte')"
        [placeholder]="'VOLUMETRY.FILTERS.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="VOLUMETRY.FILTERS.ERRORS"
        [min]="filterForm.get('scheduledAtGte').value"
      ></fc-date-input>
    </div>

    <div class="filter__content__date">
      <span class="filter__content__date__title">{{ 'VOLUMETRY.FILTERS.CLOSED_AT' | translate }}</span>

      <fc-date-input
        [control]="filterForm.get('closedAtGte')"
        [placeholder]="'VOLUMETRY.FILTERS.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="VOLUMETRY.FILTERS.ERRORS"
        [max]="filterForm.get('closedAtLte').value"
      ></fc-date-input>
      <span>{{ 'VOLUMETRY.FILTERS.UNTIL' | translate }}</span>
      <fc-date-input
        [control]="filterForm.get('closedAtLte')"
        [placeholder]="'VOLUMETRY.FILTERS.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="VOLUMETRY.FILTERS.ERRORS"
        [min]="filterForm.get('closedAtGte').value"
      ></fc-date-input>
    </div>

    <fc-locations-input [control]="filterForm.get('locations')"></fc-locations-input>
    <fc-maintenance-types-input [control]="filterForm.get('maintenanceTypes')"></fc-maintenance-types-input>
    <fc-companies-input [control]="filterForm.get('companies')"></fc-companies-input>
    <fc-location-groups-input [control]="filterForm.get('locationGroups')"></fc-location-groups-input>
    <fc-segments-input [control]="filterForm.get('segments')"></fc-segments-input>
  </div>
</div>
